export const alloysPartnersShopifyIntegrationIdFetchProductMetafields =
  "/alloys/partners/shopify/:integration_id/fetch_product_metafields";
